import type { IVariable } from "@bbj-types/utils";
import { Box, Typography } from "@mui/material";
import { EditorV2 } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { INotifyByEmailModalForm } from "../types";

export interface IEmailContentProps {
  control: Control<INotifyByEmailModalForm, void>;
  variables: IVariable[];
}

export const EmailContent = ({ control, variables }: IEmailContentProps) => {
  return (
    <Controller
      control={control}
      name="content"
      render={({ field: { value, onChange }, formState: { errors } }) => (
        <Box
          sx={{
            height: 210,
          }}
        >
          <EditorV2
            variableList={variables}
            value={value?.html ?? ""}
            onChange={(newHtml, newText) => onChange({ html: newHtml ?? "", text: newText ?? "" })}
            init={{
              // biome-ignore lint/style/useNamingConvention: TinyMCE option uses snake_case
              max_height: 210,
            }}
          />
          {errors?.content?.html && (
            <Typography
              sx={[
                {
                  ml: 2,
                },
                (theme) => ({ color: theme.palette.error.main }),
              ]}
            >
              {errors.content.html.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};
